function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect, useRef } from 'react';
import { toCapitalString } from "../utils";
import { usePrevious } from "./usePrevious";
/**
 * 处理参数变化
 * */
export function usePropsReactive(props, instanceRef) {
  var _usePrevious;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$setterMap = _ref.setterMap,
    setterMap = _ref$setterMap === void 0 ? {} : _ref$setterMap,
    _ref$converterMap = _ref.converterMap,
    converterMap = _ref$converterMap === void 0 ? {} : _ref$converterMap;
  /** 上一次渲染时 Props 值 */
  var prevProps = (_usePrevious = usePrevious(props)) !== null && _usePrevious !== void 0 ? _usePrevious : {};
  /** 已经注册的事件 */
  var registeredEvents = useRef([]);
  /** 实例是否已经创建成功 */
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  useEffect(function () {
    if (!instanceRef.current) return;
    reactivePropChange(props, true);
  }, [props]);
  useEffect(function () {
    return function () {
      if (!instanceRef.current) return;
      try {
        if ('destroy' in instanceRef.current) {
          instanceRef.current.destroy();
        }
        if ('hide' in instanceRef.current) {
          instanceRef.current.hide();
        }
        if ('map' in props && 'setMap' in instanceRef.current) {
          instanceRef.current.setMap(null);
        }
      } catch (err) {}
    };
  }, []);

  /**
   * 影响实例创建事件
   * @param instance
   */
  var onInstanceCreated = function onInstanceCreated(instance) {
    setLoaded(true);
    if ('events' in props && instance) {
      var _props$events$created, _props$events;
      // @ts-ignore
      (_props$events$created = (_props$events = props['events']).created) === null || _props$events$created === void 0 ? void 0 : _props$events$created.call(_props$events, instance);
    }
    reactivePropChange(props, false);
  };

  /**
   * 对参数变化进行处理
   * @param nextProps
   * @param shouldDetectChange
   * @returns
   */
  var reactivePropChange = function reactivePropChange() {
    var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldDetectChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var instance = instanceRef.current;
    if (!instance) return;
    try {
      Object.keys(nextProps).forEach(function (key) {
        if (key === 'events') {
          return createEventsProxy(nextProps);
        }
        var willReactive = true;
        if (shouldDetectChange) {
          willReactive = detectPropChange(key, nextProps, prevProps);
        }
        if (!willReactive) return;
        var setterParam = nextProps[key];

        // 对值进行转换
        if (key in converterMap) {
          setterParam = converterMap[key](nextProps[key]);
        }
        if (key in setterMap) {
          setterMap[key](setterParam, instance);
        } else {
          var trySetterName = "set".concat(toCapitalString(key));
          if (trySetterName in instance) {
            instance[trySetterName](setterParam);
          }
        }
      });
    } catch (err) {}
  };

  /**
   * 处理事件绑定
   * @param props
   */
  var createEventsProxy = function createEventsProxy(props) {
    var instance = instanceRef.current;
    var events = Object.keys(props.events || {});
    events.length && events.forEach(function (event) {
      if (registeredEvents.current.indexOf(event) === -1) {
        registeredEvents.current.push(event);
        instance.on(event, function (ev) {
          return function () {
            if (props.events && ev in props.events) {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              props.events[ev].apply(null, args);
            }
          };
        }(event));
      }
    });
  };

  /**
   * 检查参数变化
   * @param key
   * @param nextProps
   * @param oldProps
   * @returns
   */
  var detectPropChange = function detectPropChange(key, nextProps, oldProps) {
    return nextProps[key] !== oldProps[key];
  };
  return {
    loaded: loaded,
    prevProps: prevProps,
    onInstanceCreated: onInstanceCreated
  };
}